global.userProfileUpdate = global.API_USER_URL+'userProfileUpdate/';
global.userPasswordUpdate = global.API_USER_URL+'userPasswordUpdate/';